import React from "react";
import { GenericPage } from "../../../../../pages";
import {
  workflowOneRoute
} from "./workflow-one.route";
import {
  workflowTwoRoute
} from "./workflow-two.route";
import {
  workflowThreeRoute
} from "./workflow-three.route";
import {
  workflowReportRoute
} from "./workflow-reports.route";



export const workflowRoute = [
  {
    path: 'one',
    element: <GenericPage />,
    children:workflowOneRoute,
  },
  {
    path: 'two',
    element: <GenericPage />,
    children:workflowTwoRoute,
  },
  {
    path: 'three',
    element: <GenericPage />,
    children:workflowThreeRoute,
  },
  {
    path: 'reports',
    element: <GenericPage />,
    children:workflowReportRoute,
  },
  
]